<template>
  <div class="codewrap script" @click.prevent="doCopy">
    <div class="code">
      <span v-if="isNotEmptyOptions || isNotEmptyMobileOptions" class="script"
        >&lt;script&gt;</span
      >
      <span
        v-if="!isNotEmptyOptions && !isNotEmptyMobileOptions"
        class="info-script"
      >
        Choose options and code will appear here
      </span>
      <span v-if="isNotEmptyOptions" class="options-title"
        >var SirvOptions <span class="pun">=</span></span
      >
      <vue-json-pretty
        v-if="isNotEmptyOptions"
        :data="getOptionsHTML"
        :show-line="false"
        :show-double-quotes="false"
      />
      <span v-if="isNotEmptyMobileOptions" class="options-title"
        >var SirvMobileOptions <span class="pun">=</span></span
      >
      <vue-json-pretty
        v-if="isNotEmptyMobileOptions"
        :data="getMobileOptionsHTML"
        :show-line="false"
        :show-double-quotes="false"
      />
      <span v-if="isNotEmptyOptions || isNotEmptyMobileOptions" class="script"
        >&lt;/script&gt;</span
      >
    </div>
  </div>
</template>
<script>
import VueJsonPretty from "@/libs/vue-json-pretty/";
import { paramsFromQueryString } from "@/utils/utils";
import quotation from "quotation";
import { additionalOptions, clearFromZoomProperties } from "../../utils/utils";

export default {
  name: "CodeScript",
  components: {
    VueJsonPretty,
  },
  props: {
    options: {
      type: String,
      default: "",
    },
    mobileOptions: {
      type: String,
      default: "",
    },
  },
  computed: {
    getOptionsHTML() {
      const options = additionalOptions(clearFromZoomProperties(this.options));
      return paramsFromQueryString(options);
    },
    getMobileOptionsHTML() {
      const options = additionalOptions(
        clearFromZoomProperties(this.mobileOptions)
      );
      return paramsFromQueryString(options);
    },
    isNotEmptyOptions() {
      return Object.keys(this.getOptionsHTML).length;
    },
    isNotEmptyMobileOptions() {
      return Object.keys(this.getMobileOptionsHTML).length;
    },
  },
  methods: {
    customFormatter(data) {
      // :custom-value-formatter="customFormatter"
      if (typeof data === "string" && data.indexOf("[") !== -1)
        return `${data},`;
      if (typeof data === "string") return `${quotation(data, "'")},`;
      if (typeof data === "number") return `${data},`;
      return `${data},`;
    },
    doCopy() {
      this.$store.dispatch("copy/setCopyAction", true);
    },
  },
};
</script>
<style lang="scss">
.info-script {
  color: #6c7683;
}
.options-title {
  color: #008;
}

.vjs-tree .vjs-tree__content {
  overflow: hidden;
  padding-right: 1em;
}
.vjs-tree.is-root {
  display: inline;
  color: #660 !important;
  font-size: 14px !important;
}
.vjs-value {
  color: #606 !important;
}
.vjs-key {
  color: #080 !important;
}
.vjs-tree.is-root div:first-child {
  display: inline;
}
.codewrap {
  height: 250px;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  padding: 10px 10px 0;
  border-radius: 4px;
  box-shadow: 0 8px 40px rgba(50, 123, 186, 0.16),
    0 4px 4px rgba(50, 123, 186, 0);
  color: #008;

  &.script {
    cursor: pointer;
  }

  &::-webkit-scrollbar {
    width: 0.2em;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }

  &::-webkit-scrollbar-thumb {
    background-color: #327bba;
    outline: 1px solid slategrey;
  }
}

.code {
  display: block;
  position: relative;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 10px 15px;
  font-size: 16px !important;
}
.pre-code {
  margin: 0;
  padding: 10px 0;
  line-height: 1;
  font-size: 12px;
  overflow-y: hidden;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    height: 0.4em;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }

  &::-webkit-scrollbar-thumb {
    background-color: #327bba;
    outline: 1px solid slategrey;
  }
}
.sirv {
  display: inline-block;
}
.script {
  display: block;
}
.tag,
.zoom .tag {
  color: #008;
}
.atn,
.zoom .atn {
  color: #606;
}
.pun {
  color: #660;
}
.atv {
  color: #080;
}
.pretty {
  display: inline;
}
</style>
